module.exports = __webpack_public_path__ + "static/media/ic_door_closed.1ecfb3f1.png";